import Vue from 'vue'
Vue.directive('focus', {
  inserted: function (el, { value }) {
    if (value) {
      el.focus()
    }
  }
})
Vue.directive('focusAuto', {
  update: function (el, { value }) {
    if (value) {
      el.focus()
    }
  }
})
export {Vue}


// WEBPACK FOOTER //
// ./src/directives/focus.js